<script lang="ts">
  import {Icon} from '@components';

  enum IconSize {
    small = 'w-3 h-3',
    normal = 'w-5 h-5'
  }

  export let className = '';
  export let loading = false;
  export let disabled = false;
  export let buttonTitle = '';
  export let options: any[] = [];
  let isOpen = false;
  let widthClass = 'w-56';
</script>

<div class="flex flex-row {widthClass} gap-0">
  <button
    on:click
    on:mouseenter
    on:mouseleave
    class="flex grow !p-3 {isOpen
      ? 'rounded-tl'
      : 'rounded-l'} h-11 bg-[#E24d72] text-base text-white hover:bg-red-700 disabled:bg-gray-400 {className} disabled:cursor-not-allowed"
    {disabled}
    title={buttonTitle}
  >
    <slot />
    {#if loading}
      <div class="order-first flex w-36 items-center">
        <Icon name="Loading" className={IconSize['normal']} />
      </div>
    {/if}
    <i class="fa-regular fa-arrow-down-to-bracket text-white"> </i>
    Download
  </button>
  {#if options.length > 0}
    <details bind:open={isOpen}>
      <summary
        class={`h-11 cursor-pointer px-2 py-2  disabled:bg-gray-400 ${isOpen ? 'rounded-tr' : 'rounded-r'} ${disabled ? 'pointer-events-none cursor-not-allowed bg-gray-400' : 'cursor-pointer bg-[#E24d72] hover:bg-red-700'}`}
      >
        <i class="fa-regular fa-angle-down"></i>
      </summary>
      <ul
        class="absolute right-12 z-10 flex flex-col overflow-hidden bg-white text-gray-100 disabled:bg-gray-400 {widthClass} "
      >
        {#each options as option}
          <button
            class="border-t-[1px] border-t-white p-4 hover:bg-gray-100"
            on:click={e => {
              isOpen = false;
              option.action(e);
            }}
          >
            <div class="flex flex-row items-center">
              <p class="flex-shrink-0 text-[15px] font-extrabold leading-[9px]">{option.title}</p>
              {#if option.isRecommended}
                <p class=" text-leading-[6px] ml-auto rounded-full bg-white p-1 text-[8px] text-white">Recommended</p>
              {/if}
            </div>
            <p class="mt-3 text-left text-[12px] font-normal leading-[14px]">{option.description}</p>
          </button>
        {/each}
      </ul>
    </details>
  {/if}
</div>

<style lang="postcss">
  button {
    @apply text-base font-bold;
    @apply cursor-pointer;
    @apply items-center justify-center gap-2;
    @apply transition-all duration-150 ease-linear;
  }
  details[open] summary {
  }

  /* details only means that it's closed*/
  details summary {
    list-style: none;
  }
  ul {
    border-radius: 0px 0px 8px 8px;
  }
  svg {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
  }
</style>
